import _toConsumableArray from "/home/node/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import { hasHiddenParent } from "./visibility.js";
import { isDesktopUp } from "./is-media.js";

var moveBackdrop = function moveBackdrop(parent, target, isAlreadyVisible) {
  var transition = isAlreadyVisible ? ".5s cubic-bezier(.75,0,0,1)" : "opacity .5s ease, visibility 0s 0s";
  parent.style.setProperty("--tds-animate-backdrop-transition", transition);
  parent.style.setProperty("--tds-animate-backdrop-opacity", "1");
  parent.style.setProperty("--tds-animate-backdrop-visibility", "inherit");

  if (target) {
    var offsetHeight = target.offsetHeight,
        offsetLeft = target.offsetLeft,
        offsetTop = target.offsetTop,
        offsetWidth = target.offsetWidth;
    parent.style.setProperty("--tds-animate-backdrop-top", "".concat(offsetTop, "px"));
    parent.style.setProperty("--tds-animate-backdrop-left", "".concat(offsetLeft, "px"));
    parent.style.setProperty("--tds-animate-backdrop-height", "".concat(offsetHeight, "px"));
    parent.style.setProperty("--tds-animate-backdrop-width", "".concat(offsetWidth, "px"));
  }
};

var hideBackdrop = function hideBackdrop(parent) {
  parent.style.setProperty("--tds-animate-backdrop-transition", "opacity .5s ease, visibility 0s .5s");
  parent.style.setProperty("--tds-animate-backdrop-opacity", "0");
  parent.style.setProperty("--tds-animate-backdrop-visibility", "hidden");
};

var animateBackdrop = function animateBackdrop(parent) {
  var _document$fonts;

  var targetElements = _toConsumableArray(parent.querySelectorAll(".tds-animate--backdrop"));

  var desktopUp = isDesktopUp();
  var isVisible = false;

  var handleMouseEnter = function handleMouseEnter(e) {
    moveBackdrop(parent, e.target, isVisible);
    isVisible = true;
  };

  var smoothReset = function smoothReset() {
    var highlightedElement = parent.querySelector(".tds--highlighted");

    if (highlightedElement && !hasHiddenParent(highlightedElement) && desktopUp) {
      moveBackdrop(parent, highlightedElement, isVisible);
      isVisible = true;
    } else {
      hideBackdrop(parent);
      isVisible = false;
    }
  };

  var hardReset = function hardReset() {
    var highlightedElement = parent.querySelector(".tds--highlighted");

    if (highlightedElement && !hasHiddenParent(highlightedElement) && desktopUp) {
      moveBackdrop(parent, highlightedElement, false);
      isVisible = true;
    } else {
      hideBackdrop(parent);
      isVisible = false;
    }
  };

  hardReset();
  targetElements.forEach(function (element) {
    element.addEventListener("mouseenter", handleMouseEnter);
  });
  window.addEventListener("resize", hardReset);
  parent.addEventListener("mouseleave", smoothReset);
  (_document$fonts = document.fonts) === null || _document$fonts === void 0 ? void 0 : _document$fonts.addEventListener("loadingdone", hardReset);
  return function () {
    var _document$fonts2;

    targetElements.forEach(function (element) {
      element.removeEventListener("mouseenter", handleMouseEnter);
    });
    window.removeEventListener("resize", hardReset);
    parent.removeEventListener("mouseleave", smoothReset);
    (_document$fonts2 = document.fonts) === null || _document$fonts2 === void 0 ? void 0 : _document$fonts2.removeEventListener("loadingdone", hardReset);
  };
};

export { animateBackdrop, hideBackdrop, moveBackdrop };